<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Activity User 
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="exportxlsActivity()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="5">
            <b-input-group >
              <b-input-group-prepend><label style="width:90px !important;">Activity Date</label></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
              <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
            </b-input-group>
            <b-input-group >
              <!-- <b-input-group-prepend><label style="width:90px !important;">Order No.</label></b-input-group-prepend>
              <b-form-input v-model="tblData.orderno" ></b-form-input> -->
              <b-input-group-prepend><span class="input-group-text" style="width:90px;">Activity</span></b-input-group-prepend>
              <b-form-select v-model="tblData.activity" :plain="true" :options="['','CHECKER','DRIVER','MASUK ETALASE','RETUR']"></b-form-select>
            </b-input-group>
        </b-col>
        <b-col  lg="5">
            <b-input-group >
              <b-input-group-prepend><label style="width:130px !important;">Input By </label></b-input-group-prepend>
              <b-form-input v-model="tblData.username" placeholder="%Nama User" ></b-form-input> 
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Customer Group</label></b-input-group-prepend>
                <b-form-select v-model="tblData.customer_group" :plain="true" :options="custgroup" @change="reloaddata"></b-form-select>
                <b-input-group-append><b-button class="btn btn-success ml-1" style="width:110px !important;" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button></b-input-group-append>
            </b-input-group>
          <b-input-group >
              <b-input-group-prepend><label style="width:130px !important;">Customer</label></b-input-group-prepend>
              <b-form-input  v-model="tblData.CustName" @change="customerChange" placeholder="Customer"></b-form-input>
              <b-input-group-append>
              <b-btn text="Button" @click="lkuCustomerShow=true" >
                  <i class="fa fa-search"></i>
              </b-btn>
              </b-input-group-append>
                <b-input-group-append><b-button class="btn btn-secondary ml-1" style="width:110px !important;" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button></b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
        <b-table
        class="mb-0"
            ref="tblPhoto"
            responsive
            striped hover 
            style="font-size:smaller;"
            :items="data"
            :fields="fields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            :key="tblData.limit" 
            @row-clicked="selectItem"
          >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowDownload(data.item)" href="#"  style="padding:0 !important;">Download</b-dropdown-item>
          <!-- <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;"> Delete</b-dropdown-item> -->
        </b-dropdown>
      </template>        

        <template v-slot:cell(modified)="data">
          <span v-if="(data.item.modified)">
          {{ data.item.modified | moment("DD-MM-YYYY HH:mm") }}
          </span>
        </template>
          <template v-slot:cell(photothumbnail)="data">
              <div style="width: 200px !important; margin: -10px; position: relative;">
                  <img :src="data.item.photothumbnail" class="img-fluid" alt />
              </div>
          </template>
        <template v-slot:cell(photoexif)="data">
          <div class="report-wraper" style="margin: -10px; width:220px !important; height:140px; font-size:xx-small;">
          {{ data.item.photoexif}}
          </div>
        </template>
        <template v-slot:cell(gps_enabled)="data">
          <p v-if="(data.item.gps_enabled)">
           Enabled : {{ data.item.gps_enabled }}
          </p>
          {{ data.item.gps_permission }}
        </template>
          </b-table>
      <b-row>
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total | numFormat}} entries
          </div>
        </b-col>
        <b-col cols="2" >
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
            </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination v-if="pagination"
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
    </b-modal>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
            <lku-customer @click="onSelectLkuCustomer" :customer_group="tblData.customer_group" ></lku-customer>
        </b-modal>        

  </div>
</template>

<script>
import moment from "moment";
import photo from "../../apis/bakeryphoto";
import activity from "../../apis/bakeryactivity";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import lkuCustomer from "../lookup/lkuCustomerGroup";
import customer from "../../apis/bakerycustomer";
import toastr from "mini-toastr";
toastr.init();

export default {
  components :{Loading,lkuCustomer},
  data() {
    return {
      fields: [
          {
            key: "activity",
            label: "Activity",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "username",
            label: "Username",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "CustName",
            label: "Customer Name",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "itemname",
            label: "Item Name",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "qty",
            label: "Quantity",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "modified",
            label: "Activity Date",
            thStyle: "width:100px",
            sortable: true
          },
      ],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'modified',
        sortDesc: false,
        headcategory:null,
        tgl1: moment().format('YYYY-MM-DD'),
        tgl2: moment().format('YYYY-MM-DD'),
        customer_group:'',
        customer_id:'',
        CustName: ''
      },
      limit:5,
      pagination: false,
      items:[],
      model:{},showFrm:false,
      lkuItemShow:false,
      itemList:{},
      lkuCustomerShow:false,
      uanguser: this.$store.state.user.matauang,
      custgroup:[
          { value: '', text: '-- ALL--' }
      ],
      isLoading:false,
      showDelConfirm: false,
      showFilter:true,
      showList:true,
      showReport:false,
      reportUrl: `${location.origin}/#load`,
        activeStatus : [{ value: '', text: '-- ALL --' },, { value: '0', text: 'Discontinued' },{ value: '1', text: 'Active/In Use' }],
        jasaMaterial : [{ value: '', text: '-- ALL --' },, { value: '0', text: 'Material ' },{ value: '1', text: 'Service' }],
      headCategories:[], itemCategories:[]
    };
  },
  computed: {
    invalidFrmdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },

  },  
  watch:{
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },      
  },
  
  created: async function(){
    try {
      const [custgroup] = await Promise.all([
                customer.group()
                ]) ;
            if(custgroup){
                 custgroup.map((data)=>{
                    this.custgroup.push({
                        value:data.value,
                        text:data.text
                    });
                });
            }
    } catch (error) {
        this.isLoading = false;
          console.log('error : ', error);
          toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
    }

  },

  methods: {

    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.photolist) {
            this.tblData[key] = filter.photolist[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.photolist.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.photolist;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=false; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await activity.list(this.tblData);
                  this.pagination=true;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
            }
        } else {
            this.isLoading=true;
            this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            try {
              const list = await activity.list(this.tblData);
              this.pagination=true;
              this.isLoading=false;  
              return list;        
            } catch (error) {
              this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
            }
        }
    },    
    selectItem(record,index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },

    async reloaddata(val) {
      // this.isLoading = true;
      this.tblData.customer_group = val;
      this.tblData.customer_id = '';
      this.tblData.CustName = '';
      // this.isLoading = false;
    },

    refresh() {
      this.$refs.tblPhoto.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.tblData.username = '';
        this.tblData.activity =  '';
        this.tblData.orderno =  '';
        this.tblData.customer_id = '';
        this.tblData.CustName =  '';
        this.tblData.tgl1 =  '';
        this.tblData.tgl2 =  '';
        this.tblData.customer_group = '';
        // this.refresh();
    },    
    customerChange: function () {
        this.tblData.customer_id = '';
    },        
    saveFilter() {
      const keys = ['tgl1', 'tgl2','orderno', 'username','activity',  'customer_id', 'CustName'];
      let filtered = false;
      const photolist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              photolist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          photolist.page=this.tblData.page;
          photolist.limit=this.tblData.limit;
          photolist.sortBy=this.tblData.sortBy;
          photolist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.photolist=photolist;
          this.$store.commit("filter", filter);
      }
    },    
    onSelectLkuCustomer: async function (_selected) {
        this.tblData.CustName = _selected.CustName.trim();
        this.tblData.CustCode = _selected.CustCode;
        this.tblData.customer_id = _selected.customer_id;
        this.lkuCustomerShow=false;
    },    
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },    
    rowDownload(record) {
      this.rowClicked(record);
      this.download();
    },    
    deleteConfirm() {
        if (this.model) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await photo.remove(this.model);
      this.refresh();
        // const index= this.items.findIndex(r => (r.itemno==this.model.itemno));
        // this.items.splice(index, 1);
        this.isLoading=false;
      } catch (error) {
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    download : async function(fl) {
        if (this.model) {
            try {
                this.isLoading=true;
                const response = await photo.download(this.model);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${this.model.remark}_${this.model.orderno}_${this.model.CustCode}.jpg`);
                document.body.appendChild(link);
                link.click();
                this.isLoading=false;    
            } catch (error) {
                    this.isLoading=false;            
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
            }
        } else {
            toastr.warn('Please select a row that want to be Download!');
        }

    }, 
    exportxlsActivity: async function() {
        this.isLoading=true;
        try {
           const response = await activity.exportxlsActivity(this.tblData);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'activity_user.xlsx');
            document.body.appendChild(link);
            link.click();
            this.isLoading=false;    
        } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
        }
    },   
    close(){
      router.push("home");
    },    
  }
};
</script>
